import NetInfo, { type NetInfoState } from "@react-native-community/netinfo";
import { useEffect, useRef, useState } from "react";

import Logging from "$src/core/services/logging/logging";

const useOnlineStatus = () => {
  const [state, setState] = useState<NetInfoState | null>(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;

    void NetInfo.fetch()
      .then((newState) => {
        if (mountedRef.current) setState(newState);
      })
      .catch((error) => {
        Logging.error("Failed to fetch online status", { error });
        if (mountedRef.current) setState(null);
      });

    const unsubscribe = NetInfo.addEventListener((newState) => {
      if (mountedRef.current) setState(newState);
    });

    return () => {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);

  const recheck = async () => {
    try {
      const newState = await NetInfo.fetch();
      if (mountedRef.current) setState(newState);
    } catch (error) {
      Logging.error("Failed to recheck online status", { error });
      if (mountedRef.current) setState(null);
    }
  };

  const isOnline = state?.isConnected ?? null;

  return { isOnline, recheck };
};

export default useOnlineStatus;
